import styled from 'styled-components';

export default styled.div`
  font-size: 0.8rem;
  display: grid;
  grid-template-columns: 75px 4fr;
  grid-column-gap: 0.5rem;
`;
